import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async action to fetch company detail list data
export const getContactDetailList = createAsyncThunk(
  "contactDetailList/getContactDetailList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/contact_us/create`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const contactDetailSlice = createSlice({
  name: "contactDetailList",
  initialState: {
    loading: false,
    contactDetailData: null,
    error: null,
  },
  reducers: {
    ResetContactState: (state) => {
      state.loading = false;
      state.contactDetailData = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getContactDetailList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getContactDetailList.fulfilled, (state, action) => {
        state.loading = false;
        state.contactDetailData = action.payload;
      })
      .addCase(getContactDetailList.rejected, (state, action) => {
        state.loading = false;
        state.contactDetailData = action.payload;
        state.error = action.payload;
      });
  },
});
export const { ResetContactState } = contactDetailSlice.actions;
export default contactDetailSlice.reducer;
